/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-expressions */
/* eslint-disable-no-extraneous-dependencies */
import React, { useEffect, useRef, useState } from "react";
import { RiDownloadLine, RiEditLine } from "react-icons/ri";
import { IoClose } from "react-icons/io5";
import { IoMdEye } from "react-icons/io";
import {
  type SubmitErrorHandler,
  type SubmitHandler,
  useForm,
} from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "react-toastify";
import { MdOutlineCloudUpload } from "react-icons/md";
import { putCreciAutonomo } from "screens/perfilAutonomo/api/putCreciAutonomo";
import { TextInputMask } from "../TextInputMask";
import { TipoCreciOptions, type FileUploadI } from "../../utils";
import TextInputZod from "../TextInputZod/textInputZod.component";
import { rNS, BooleanOptions, TipoCreciC, COLORS } from "../../utils";
import { MAX_UPLOAD_SIZE } from "../FileUploadModal/utils";
import { type EditCreciFormValues, schema } from "./schemas";
import * as S from "./styles";
import * as Styles from "../modal.styles";
import { SelectComponent } from "../SelectComponent";
import { DatePicker } from "../DatePicker";
import { SecondaryButton } from "../secondaryButton.component";
import { PrimaryButton } from "../primaryButton.component";
import { Loading } from "../Loading";

const accept = "image/png, image/jpeg, image/jpg, application/pdf";
const defaultFiles = {
  carteiraFrente: null,
  carteiraVerso: null,
  certidaoCreciJuridico: null,
  cartaoCnpj: null,
};

const uploadButtonContent = (
  <div
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      fontFamily: "Inter",
    }}
  >
    <p style={{ color: COLORS.primary500, fontSize: 16, fontWeight: 500 }}>
      Anexar
    </p>
    <MdOutlineCloudUpload size={20} />
  </div>
);

export const CreciModal = ({
  isOpen,
  onClose,
  user,
  authToken,
}: {
  isOpen: boolean;
  onClose: () => void;
  user: any;
  authToken: string;
}) => {
  const [files, setFiles] = useState<{
    carteiraFrente: FileUploadI | null;
    carteiraVerso: FileUploadI | null;
    certidaoCreciJuridico: FileUploadI | null;
    cartaoCnpj: FileUploadI | null;
  }>(defaultFiles);
  const [currentFileUpload, setCurrentFileUpload] = useState<
    keyof typeof files | null
  >(null);
  const [saving, setSaving] = useState(false);
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm<EditCreciFormValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      idTipoCreci: "",
      numero: "",
      dataVencimento: null,
      isJuridico: undefined,
      razaoSocial: "",
      numeroCnpj: "",
      enderecoFiscal: "",
      escola: "",
    },
  });

  const idTipoCreciValue = watch("idTipoCreci");
  const numeroValue = watch("numero");
  const dataVencimentoValue = watch("dataVencimento");
  const isJuridicoValue = watch("isJuridico");
  const numeroCnpjValue = watch("numeroCnpj");

  useEffect(() => {
    if (isOpen) {
      setValue("bandeira", user?.bandeira?.toLowerCase() ?? "");
      setValue("idTipoCreci", user?.creci?.idTipoCreci ?? "");
      setValue("numero", user?.creci?.numeroCreci ?? "");
      setValue(
        "dataVencimento",
        user?.creci?.dataVencimento ? new Date(user.creci.dataVencimento) : null
      );
      setValue("isJuridico", user?.creci?.isJuridico ?? false);
      setValue("razaoSocial", user?.creci?.razaoSocial ?? "");
      setValue("numeroCnpj", user?.creci?.cnpj ?? "");
      setValue("enderecoFiscal", user?.creci?.enderecoFiscal ?? "");
      setValue(
        "certidaoCreciJuridico",
        user?.creci?.arquivoJuridicoFrente
          ? user.creci.arquivoJuridicoFrente?.nome
          : null
      );
      setValue(
        "cartaoCnpj",
        user?.creci?.arquivoCNPJ ? user.creci.arquivoCNPJ?.nome : null
      );
    } else {
      setFiles(defaultFiles);
      setCurrentFileUpload(null);
    }
  }, [isOpen]);

  const hasChanged = () => {
    if (
      user?.creci?.idTipoCreci === idTipoCreciValue &&
      user?.creci?.numeroCreci === numeroValue &&
      user?.creci?.isJuridico === isJuridicoValue &&
      user?.creci?.dataVencimento &&
      new Date(user?.creci?.dataVencimento)?.getTime() ===
        dataVencimentoValue?.getTime()
    ) {
      if (
        isJuridicoValue === true &&
        (user?.creci?.razaoSocial !== getValues("razaoSocial") ||
          user?.creci?.cnpj !== getValues("numeroCnpj") ||
          user?.creci?.enderecoFiscal !== getValues("enderecoFiscal"))
      ) {
        return true;
      }

      return false;
    }

    return true;
  };

  const handleFileUpload = (property: keyof typeof files) => {
    setCurrentFileUpload(property);

    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const acceptedTypes =
        accept?.split(",").map((type: string) => type.trim()) ?? [];
      const isValidType = acceptedTypes.some(
        (type) =>
          file.type === type ||
          (type.includes("*") && file.name.endsWith(type.replace("*", "")))
      );

      if (!isValidType) {
        toast.error("Formato de arquivo inválido");
      } else if (file.size > MAX_UPLOAD_SIZE) {
        toast.error(
          `Tamanho do arquivo deve ser menor que ${
            MAX_UPLOAD_SIZE / 1024 / 1024
          }MB`
        );
      } else {
        const reader = new FileReader();
        reader.onload = () => {
          const newFile = {
            nome: file.name,
            base64: String(reader?.result).split(",").pop() as string,
            contentType: file.type,
          };

          if (currentFileUpload) {
            setFiles((prev) => ({ ...prev, [currentFileUpload]: newFile }));
            setValue(`${currentFileUpload}`, newFile.nome);
            setCurrentFileUpload(null);
          }

          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const download = async (fileUrl: string) => {
    try {
      const response = await fetch(fileUrl);
      if (!response.ok)
        throw new Error(`Error fetching file: ${response.statusText}`);

      const blob = await response.blob();
      const downloadUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = fileUrl.split("/").pop() ?? "download";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      toast.error("Erro ao baixar o arquivo");
      console.error("Download failed:", error);
    }
  };

  const handleFileActions = (fileUrl: string, action: "open" | "download") => {
    if (!fileUrl) {
      toast.error("URL do arquivo não encontrada");
      return;
    }
    if (action === "download") {
      download(fileUrl);
    } else {
      window.open(fileUrl);
    }
  };

  const submit = () => {
    if (hasChanged()) {
      if (
        (user?.bandeira?.toLowerCase() === "vivaz" || !isJuridicoValue) &&
        (!files.carteiraFrente || !files.carteiraVerso)
      ) {
        return toast.info(
          "Alterações no CRECI necessitam de um novo envio de carteira frente e verso"
        );
      }

      if (
        user?.bandeira?.toLowerCase() !== "vivaz" &&
        isJuridicoValue &&
        (!files.certidaoCreciJuridico || !files.cartaoCnpj)
      ) {
        return toast.info(
          "Alterações no CRECI jurídico necessitam de um novo envio de certidão e cartão CNPJ"
        );
      }

      return handleSubmit(onSubmit, onError)();
    }

    return handleSubmit(onSubmit, onError)();
  };

  const onSubmit: SubmitHandler<EditCreciFormValues> = (data) => {
    setSaving(true);

    if (!files.carteiraFrente || !files.carteiraVerso) {
      toast.error(
        "Carteira frente e verso são obrigatórios para alterações no CRECI."
      );
      setSaving(false);
      return;
    }

    putCreciAutonomo({
      idAutonomo: user?.id,
      idTipoCreci: data?.idTipoCreci ?? user?.creci?.tipoCreci?.id,
      numero: data?.numero,
      dataVencimento: data?.dataVencimento,
      carteiraFrente: files.carteiraFrente,
      carteiraVerso: files.carteiraVerso,
      isJuridico: data?.isJuridico ?? false,
      razaoSocial: data?.isJuridico ? data?.razaoSocial : undefined,
      cnpj: data?.isJuridico ? data?.numeroCnpj : undefined,
      codigoVerificacao:
        data?.idTipoCreci === TipoCreciC.ESTAGIARIO ? data?.numero : undefined,
      enderecoFiscal: data?.isJuridico ? data?.enderecoFiscal : undefined,
      escolaTTi:
        data?.idTipoCreci === TipoCreciC.ESTAGIARIO ? data?.escola : undefined,
      carteiraCreciJuridicoFrente: data?.isJuridico
        ? files.certidaoCreciJuridico ?? null
        : null,
      carteiraCreciJuridicoVerso: null,
      cartaoCNPJ: data?.isJuridico ? files.cartaoCnpj ?? null : null,
      authToken: authToken ?? "",
    })
      .then(({ success, notifications }) => {
        if (success) {
          toast.success(
            "Solicitação de alteração de CRECI enviada com sucesso"
          );
          onClose();
        } else if (!success && notifications?.length > 0) {
          toast.info(notifications?.[0]?.message);
        } else throw new Error();
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          "Erro ao solicitar alteração de CRECI, por favor tente novamente"
        );
      })
      .finally(() => {
        setSaving(false);
      });
  };

  const onError: SubmitErrorHandler<EditCreciFormValues> = (errors) => {
    Object.keys(errors).length > 0 &&
      toast.error(
        "Por favor, verifique novamente os campos obrigatórios e dados inválidos."
      );
  };

  const cannotSave =
    (idTipoCreciValue !== TipoCreciC.ESTAGIARIO &&
      idTipoCreciValue !== TipoCreciC.DEFINITIVO) ||
    getValues("numero")?.trim() === "";

  return (
    <Styles.DialogContainer open={isOpen} onClose={onClose} maxWidth="md">
      <Styles.Container>
        <Styles.IconContainer>
          <div className="icon-wrapper">
            <RiEditLine color={COLORS.green} />
          </div>
          <h1 className="title center">{"Editar CRECI"}</h1>
          <IoClose size={26} className="exit" onClick={onClose} />
        </Styles.IconContainer>

        <S.Form>
          <S.Row template="1fr 1fr 1fr 1fr 1fr">
            <S.Field>
              <p>Tipo de CRECI</p>
              <SelectComponent
                data={TipoCreciOptions}
                value={idTipoCreciValue}
                onChange={(val: string) => {
                  if (user?.creci?.idTipoCreci === TipoCreciC.DEFINITIVO)
                    return;
                  val === TipoCreciC.ESTAGIARIO &&
                    setValue("isJuridico", undefined);
                  setValue("idTipoCreci", val);
                }}
                disabled={user?.creci?.idTipoCreci === TipoCreciC.DEFINITIVO}
                isError={!!errors.idTipoCreci}
                renderLabel
              />
            </S.Field>
            <S.Field>
              <p>
                {idTipoCreciValue === TipoCreciC.ESTAGIARIO
                  ? "Código de Verificação"
                  : "Número"}
              </p>
              <TextInputMask
                mask="999999999999999999"
                placeholder=""
                value={numeroValue}
                onChange={(val) => {
                  setValue("numero", val);
                }}
                isError={!!errors.numero}
              />
            </S.Field>
            <S.Field>
              <p>Data de Vencimento</p>
              <DatePicker
                value={dataVencimentoValue}
                onChange={(val: Date) => {
                  setValue("dataVencimento", val);
                }}
                isError={!!errors.dataVencimento}
              />
            </S.Field>
            <S.Field>
              <p>Carteira Frente</p>
              <S.FileHub isError={!!errors.carteiraFrente}>
                <IoMdEye
                  size={28}
                  className={`icon ${!!files.carteiraFrente && "disabled"}`}
                  onClick={() => {
                    !files.carteiraFrente &&
                      handleFileActions(
                        user?.creci?.arquivoFrente?.url,
                        "open"
                      );
                  }}
                />
                <RiEditLine
                  size={28}
                  className="icon"
                  onClick={() => {
                    handleFileUpload("carteiraFrente");
                  }}
                />
                <RiDownloadLine
                  size={28}
                  className={`icon ${!!files.carteiraFrente && "disabled"}`}
                  onClick={() => {
                    !files.carteiraFrente &&
                      handleFileActions(
                        user?.creci?.arquivoFrente?.url,
                        "download"
                      );
                  }}
                />
              </S.FileHub>
            </S.Field>
            <S.Field>
              <p>Carteira Verso</p>
              <S.FileHub isError={!!errors.carteiraVerso}>
                <IoMdEye
                  size={28}
                  className={`icon ${!!files.carteiraVerso && "disabled"}`}
                  onClick={() => {
                    !files.carteiraVerso &&
                      handleFileActions(user?.creci?.arquivoVerso?.url, "open");
                  }}
                />
                <RiEditLine
                  size={28}
                  className="icon"
                  onClick={() => {
                    handleFileUpload("carteiraVerso");
                  }}
                />
                <RiDownloadLine
                  size={28}
                  className={`icon ${!!files.carteiraVerso && "disabled"}`}
                  onClick={() => {
                    !files.carteiraVerso &&
                      handleFileActions(
                        user?.creci?.arquivoVerso?.url,
                        "download"
                      );
                  }}
                />
              </S.FileHub>
            </S.Field>
          </S.Row>

          {idTipoCreciValue === TipoCreciC.ESTAGIARIO ? (
            <>
              <S.Divider />

              <S.Row template="1fr">
                <S.Field>
                  <p>Escola TTI</p>
                  <TextInputZod
                    placeholder="Nome da Escola"
                    property="escola"
                    register={register}
                    errors={errors}
                  />
                </S.Field>
              </S.Row>
            </>
          ) : user?.bandeira?.toLowerCase() !== "vivaz" ? (
            <>
              <S.Divider />

              <S.Row template="2.5fr 5fr 2.5fr">
                <S.Field>
                  <p>Possui CRECI Jurídico?</p>
                  <SelectComponent
                    data={BooleanOptions}
                    value={isJuridicoValue}
                    onChange={(val: boolean) => {
                      setValue("isJuridico", val);
                    }}
                    isError={
                      !!errors.isJuridico &&
                      typeof isJuridicoValue !== "boolean"
                    }
                    renderLabel
                  />
                </S.Field>
                {isJuridicoValue ? (
                  <>
                    <S.Field>
                      <p>Razão Social</p>
                      <TextInputZod
                        placeholder="Nome Jurídico"
                        property="razaoSocial"
                        register={register}
                        errors={errors}
                        isError={
                          !!errors?.isJuridico &&
                          getValues("razaoSocial")?.trim() === ""
                        }
                      />
                    </S.Field>
                    <S.Field>
                      <p>Número CNPJ</p>
                      <TextInputMask
                        mask="99.999.999/9999-99"
                        placeholder="XX.XXX.XXX/0001-XX"
                        value={numeroCnpjValue}
                        onChange={(val: string) => {
                          setValue("numeroCnpj", rNS(val));
                        }}
                        isError={
                          !!errors?.isJuridico && numeroCnpjValue?.trim() === ""
                        }
                      />
                    </S.Field>
                  </>
                ) : (
                  <div id="dummy" />
                )}
              </S.Row>

              {isJuridicoValue && (
                <>
                  <S.Row template="1fr">
                    <S.Field>
                      <p>Endereço CNPJ</p>
                      <TextInputZod
                        placeholder="Endereço"
                        property="enderecoFiscal"
                        register={register}
                        isError={
                          !!errors?.isJuridico &&
                          getValues("enderecoFiscal")?.trim() === ""
                        }
                      />
                    </S.Field>
                  </S.Row>

                  <S.FilesUpload>
                    <S.Field style={{ maxWidth: "max-content" }}>
                      <p>
                        {"Certidão CRECI Jurídico "}
                        <span>*</span>
                      </p>
                      {user?.creci?.certidaoCreciJuridico ||
                      files.certidaoCreciJuridico ? (
                        <S.FileHub style={{ width: 200 }}>
                          <IoMdEye
                            size={28}
                            className={`icon ${
                              !!files.certidaoCreciJuridico && "disabled"
                            }`}
                            onClick={() => {
                              !files.certidaoCreciJuridico &&
                                handleFileActions(
                                  user?.creci?.certidaoCreciJuridico?.url,
                                  "open"
                                );
                            }}
                          />
                          <RiEditLine
                            size={28}
                            className="icon"
                            onClick={() => {
                              handleFileUpload("certidaoCreciJuridico");
                            }}
                          />
                          <RiDownloadLine
                            size={28}
                            className={`icon ${
                              !!files.certidaoCreciJuridico && "disabled"
                            }`}
                            onClick={() => {
                              !files.certidaoCreciJuridico &&
                                handleFileActions(
                                  user?.creci?.certidaoCreciJuridico?.url,
                                  "download"
                                );
                            }}
                          />
                        </S.FileHub>
                      ) : (
                        <SecondaryButton
                          content={uploadButtonContent}
                          style={{ width: 200, height: 44 }}
                          onClick={() => {
                            handleFileUpload("certidaoCreciJuridico");
                          }}
                        />
                      )}
                    </S.Field>
                    <S.Field style={{ maxWidth: "max-content" }}>
                      <p>
                        {"Cartão CNPJ "}
                        <span>*</span>
                      </p>
                      {user?.creci?.arquivoCNPJ || files.cartaoCnpj ? (
                        <S.FileHub style={{ width: 200 }}>
                          <IoMdEye
                            size={28}
                            className={`icon ${
                              !!files.cartaoCnpj && "disabled"
                            }`}
                            onClick={() => {
                              !files.cartaoCnpj &&
                                handleFileActions(
                                  user?.creci?.arquivoCNPJ?.url,
                                  "open"
                                );
                            }}
                          />
                          <RiEditLine
                            size={28}
                            className="icon"
                            onClick={() => {
                              handleFileUpload("cartaoCnpj");
                            }}
                          />
                          <RiDownloadLine
                            size={28}
                            className={`icon ${
                              !!files.cartaoCnpj && "disabled"
                            }`}
                            onClick={() => {
                              !files.cartaoCnpj &&
                                handleFileActions(
                                  user?.creci?.arquivoCNPJ?.url,
                                  "download"
                                );
                            }}
                          />
                        </S.FileHub>
                      ) : (
                        <SecondaryButton
                          content={uploadButtonContent}
                          style={{ width: 200, height: 44 }}
                          onClick={() => {
                            handleFileUpload("cartaoCnpj");
                          }}
                        />
                      )}
                    </S.Field>
                  </S.FilesUpload>
                </>
              )}
            </>
          ) : null}
        </S.Form>

        <S.Buttons style={{ marginTop: 10 }}>
          <div id="dummy" />
          <S.Buttons>
            <SecondaryButton content="Cancelar" onClick={onClose} />
            <PrimaryButton
              content={saving ? <Loading size={18} color="white" /> : "Salvar"}
              onClick={submit}
              disabled={saving || cannotSave}
            />
          </S.Buttons>
        </S.Buttons>
        <input
          type="file"
          ref={fileInputRef}
          accept={accept}
          onChange={handleFileChange}
          style={{ display: "none" }}
        />
      </Styles.Container>
    </Styles.DialogContainer>
  );
};
